module.exports = __webpack_public_path__ + "static/img/eggenberger.00f28ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/eggenberger.png
// module id = 482
// module chunks = 1